// @flow

import * as React from 'react';

import { selectIsFailureOneOrder } from '@gandi/billing';

import { selectCartUUID } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Alert, Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import styles from './OrderError.scss';

type Props = { orderId: string | number };

export default function OrderError({ orderId }: Props): React.MixedElement {
  const translator = useTranslator();
  const { __ } = translator;
  const cartId = useAppSelector(selectCartUUID);
  const isFailure = useAppSelector(state =>
    // $FlowFixMe[incompatible-call]
    selectIsFailureOneOrder(state, { orderId }),
  );

  const message = isFailure
    ? __('Unable to retrieve this order.')
    : __('This order is invalid.');

  return (
    <>
      <Base marginBottom="base">
        <Alert message={message} intent="danger" />
      </Base>
      <div className={styles.center}>
        <Button href={`/cart/${cartId}/overview/${orderId}`}>
          {__('Return to the cart overview')}
        </Button>
      </div>
    </>
  );
}
